import { appDefaults } from "common/themes/default.theme";

const layoutStyles = (theme) => {
  const { sidebarWidth, headerHeight, footerHeight } = appDefaults;

  return {
    wrapper: {
      display: "flex",
      flexDirection: "column-reverse",
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
      },
    },
    sidebar: {
      width: "100%",
      height: footerHeight,
      [theme.breakpoints.up("sm")]: {
        width: sidebarWidth,
        height: "100%",
      },
    },
    content: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${sidebarWidth}px)`,
      },
    },
    header: {
      height: headerHeight,
    },
    main: {
      width: "100%",
      height: `calc(100% - ${sidebarWidth}px)`,
      [theme.breakpoints.up("sm")]: {
        height: `calc(100% - ${headerHeight}px)`,
      },
    },
  };
};

export default layoutStyles;
